// assets/acanto-factura.js (Domi, 2026-10-27): caja "¿Boleta o factura?" del carrito (snippets/acanto-factura-carrito.liquid).
// Guarda la elección y los datos de factura como atributos del carrito, y no deja pasar a pagar con la factura incompleta.
// Todo va delegado en document porque Horizon vuelve a pintar el carrito con cada cambio.
(function () {
  var CAMPOS = ['Razón social', 'RUT', 'Giro', 'Dirección facturación'];
  var espera;
  var pasando = false;

  function guardar(atributos) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: atributos })
    });
  }

  function datosDe(caja) {
    var datos = { Documento: caja.querySelector('[aria-pressed="true"]').dataset.documento };
    caja.querySelectorAll('[data-atributo]').forEach(function (input) {
      datos[input.dataset.atributo] = datos.Documento === 'Factura' ? input.value.trim() : '';
    });
    return datos;
  }

  function rutValido(valor) {
    var limpio = valor.replace(/[^0-9kK]/g, '').toUpperCase();
    if (limpio.length < 8) return false;
    var cuerpo = limpio.slice(0, -1), dv = limpio.slice(-1), suma = 0, mult = 2;
    for (var i = cuerpo.length - 1; i >= 0; i--) { suma += +cuerpo[i] * mult; mult = mult === 7 ? 2 : mult + 1; }
    var esperado = 11 - (suma % 11);
    return dv === (esperado === 11 ? '0' : esperado === 10 ? 'K' : String(esperado));
  }

  function formatearRut(valor) {
    var limpio = valor.replace(/[^0-9kK]/g, '').toUpperCase();
    if (limpio.length < 2) return limpio;
    return limpio.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '-' + limpio.slice(-1);
  }

  function revisarRut(input) {
    var ok = !input.value || rutValido(input.value);
    input.setAttribute('aria-invalid', ok ? 'false' : 'true');
    input.setCustomValidity(ok ? '' : 'Revisa el RUT, no parece válido.');
    input.parentElement.querySelector('.acanto-doc__error').hidden = ok;
    return ok;
  }

  function pintar(caja, documento) {
    var factura = documento === 'Factura';
    caja.querySelectorAll('[data-documento]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.documento === documento));
    });
    caja.querySelector('.acanto-doc__factura').hidden = !factura;
    caja.querySelectorAll('[data-atributo]').forEach(function (input) { input.required = factura; });
  }

  // El carrito lateral y la página del carrito pueden estar a la vez en pantalla: se mantienen iguales.
  function sincronizar(origen) {
    var documento = origen.querySelector('[aria-pressed="true"]').dataset.documento;
    document.querySelectorAll('[data-acanto-doc]').forEach(function (caja) {
      if (caja === origen) return;
      pintar(caja, documento);
      origen.querySelectorAll('[data-atributo]').forEach(function (input) {
        caja.querySelector('[data-atributo="' + input.dataset.atributo + '"]').value = input.value;
      });
    });
  }

  function cajaDe(elemento) {
    while (elemento && !(elemento.querySelector && elemento.querySelector('[data-acanto-doc]'))) elemento = elemento.parentElement;
    return elemento && elemento.querySelector('[data-acanto-doc]');
  }

  document.addEventListener('click', function (e) {
    var boton = e.target.closest('[data-acanto-doc] [data-documento]');
    if (!boton) return;
    var caja = boton.closest('[data-acanto-doc]');
    pintar(caja, boton.dataset.documento);
    sincronizar(caja);
    guardar(datosDe(caja));
    if (boton.dataset.documento === 'Factura') caja.querySelector('[data-atributo]').focus();
  });

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-acanto-doc] [data-atributo]');
    if (!input) return;
    var caja = input.closest('[data-acanto-doc]');
    clearTimeout(espera);
    espera = setTimeout(function () { sincronizar(caja); guardar(datosDe(caja)); }, 500);
  });

  document.addEventListener('focusout', function (e) {
    var input = e.target.closest('[data-acanto-doc] [data-atributo="RUT"]');
    if (!input || !input.value) return;
    input.value = formatearRut(input.value);
    revisarRut(input);
  });

  // Antes de ir a pagar: si pidió factura, todo completo y el RUT válido; y los datos ya guardados en el carrito.
  document.addEventListener('click', function (e) {
    var pagar = e.target.closest('[name="checkout"]');
    if (!pagar || pasando) return;
    var caja = cajaDe(pagar);
    if (!caja) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var datos = datosDe(caja);
    if (datos.Documento === 'Factura') {
      pintar(caja, 'Factura');
      var rut = caja.querySelector('[data-atributo="RUT"]');
      rut.value = formatearRut(rut.value);
      revisarRut(rut);
      var malo = Array.prototype.find.call(caja.querySelectorAll('[data-atributo]'), function (input) { return !input.checkValidity(); });
      if (malo) {
        malo.scrollIntoView({ block: 'center' });
        malo.reportValidity();
        return;
      }
      datos = datosDe(caja);
    }

    clearTimeout(espera);
    guardar(datos).finally(function () {
      pasando = true;
      pagar.click();
      pasando = false;
    });
  }, true);
})();
